import './modal-status-round.scss';
import Button from '../../components/button/button';
import LocalStorage from '../../services/local-storage';
import { SESSION, ASSETS, SCORE } from '../../constants';
import { useState } from 'react';
import { useNavigate } from "react-router-dom";
import TranslateService from '../../services/translate-service';
import UtilsService from '../../services/utils-service';

export default function ModalStatusRound(props) {

    const navigate = useNavigate();

    // const [team] = useState(LocalStorage.get(TEAM));
    const [session] = useState(LocalStorage.get(SESSION));
    const [score] = useState(LocalStorage.get(SCORE));

    const handleDone = () => {
        if(!props.details.nextRound) {
            navigate('/');
        } else {
            navigate(`/individual-challenge/round`, { replace: true, state: { round: props.details.nextRound, reload:  props.details.nextRound.rondaActual } });
        }
    }

    return (
        <div className="modal-status-round">
            <div className={'modal-status-round-content ' +(props.details.status === 1 ? 'winner': '') }>
                <div className='text-center'>
                    <p className='heading-h7 uppercase !text-secundary text-winner'>{props.details.status === 0 ? TranslateService.get('indivualChall.challenges.round.modal.headerHold'): TranslateService.get('indivualChall.challenges.round.modal.header')}</p>

                    {!props.details.nextRound &&
                        <div className='rounded-full avatar m-auto mt-[48px] mb-[24px]'>
                            <img src={`${ASSETS.AVATAR_PLAYER}${session.avatar}`} alt='' className='rounded-full m-auto w-[80px]' />
                        </div>
                    }
                   
                    {props.details.nextRound &&
                        <div className='h-[40px] w-[40px] text-[40px] mx-auto mt-[24px]'>
                            {props.details.status === -1 && '🙁'} 
                            {props.details.status === 1 && '😎'}
                        </div>
                    }
                    

                    {!props.details.nextRound && <p className='heading-h3 winner-heading'>{TranslateService.get('indivualChall.challenges.round.modal.titleHold')}</p>}
                    
                    {props.details.nextRound && props.details.status === -1 && <p className='heading-h3 winner-heading'>{TranslateService.get('indivualChall.challenges.round.modal.titleLost')}</p>}
                    {props.details.nextRound && props.details.status === 1 && <p className='heading-h3 winner-heading'>{TranslateService.get('indivualChall.challenges.round.modal.titleWon')}</p>}
                    
                    {props.details.nextRound && 
                        <div className='flex items-center max-w-[60%] m-auto mt-[40px] mb-[8px]'>

                            <div>
                                <div className='rounded-full avatar m-auto w-[48px]'>
                                    <img src={`${ASSETS.AVATAR_PLAYER}${session.avatar}`} alt='' className='rounded-full m-auto ' />
                                </div>
                                <p className='heading-h5 !text-default winner-heading my-[4px]'>You</p>
                                <p className='heading-h6 !text-secundary text-winner'>{UtilsService.format(score)}pts</p>
                            </div>
                            <div className='grow heading-h5 winner-heading'>VS</div>
                            <div>
                                <div className='rounded-full avatar m-auto w-[48px]'>
                                    <img src={`${ASSETS.AVATAR_PLAYER}${props.details.nextRound.oponente.avatar}`} alt='' className='rounded-full m-auto ' />
                                </div>
                                <p className='heading-h5 !text-default winner-heading my-[4px]'>{UtilsService.capitalize(props.details.nextRound.oponente.nombre, props.details.nextRound.oponente.apellidoPaterno) }.</p>
                                <p className='heading-h6 !text-secundary text-winner'>{UtilsService.format(props.details.nextRound.oponente.score)}pts</p>
                            </div>

                        </div>
                    }

                    {props.details.status === 0 &&
                        <div className='card max-w-[60%] m-auto mb-[24px] mt-[16px]'>
                            <div className='flex items-center'>
                                <p className='grow text-secundary text-left '>{TranslateService.get('indivualChall.challenges.round.modal.scoreC')}</p>
                                <p className='heading-h6 text-right'>{props.details.me.challengeScore} pts</p>
                            </div>
                            <div className='flex items-center mt-[16px] separator-bottom pb-[16px]'>
                                <p className='grow text-secundary text-left '>{TranslateService.get('indivualChall.challenges.round.modal.scoreR')}</p>
                                <p className='heading-h6 text-right'>{props.details.me.roundScore} pts</p>
                            </div>
                            <div className='flex items-center mt-[16px]'>
                                <p className='grow text-secundary text-left '>{TranslateService.get('indivualChall.challenges.round.modal.right')}</p>
                                <p className='heading-h6 text-right'>{props.details.me.right}</p>
                            </div>
                            <div className='flex items-center mt-[16px] separator-bottom pb-[16px]'>
                                <p className='grow text-secundary text-left '>{TranslateService.get('indivualChall.challenges.round.modal.time')}</p>
                                <p className='heading-h6 text-right'>{UtilsService.round(props.details.me.time)}s</p>
                            </div>
                            <div className='flex items-center mt-[16px]'>
                                <p className='grow text-secundary text-left '>{TranslateService.get('indivualChall.challenges.round.modal.wrong')}</p>
                                <p className='heading-h6 text-right'>{props.details.me.wrong}</p>
                            </div>
                            <div className='flex items-center mt-[16px]'>
                                <p className='grow text-secundary text-left '>{TranslateService.get('indivualChall.challenges.round.modal.won')}</p>
                                <p className='heading-h6 text-right'>{props.details.me.roundsWon}</p>
                            </div>
                        </div>
                    }

                    {props.details.status !== 0 && 
                        <div className='card max-w-[60%] m-auto mb-[24px] mt-[16px]'>
                            <div className='flex items-center'>
                                <p className='heading-h6 text-left'>{props.details.me.challengeScore} pts</p>
                                <p className='grow text-secundary text-center '>{TranslateService.get('indivualChall.challenges.round.modal.scoreC')}</p>
                                <p className='heading-h6 text-right'>{props.details.opponent.challengeScore} pts</p>
                            </div>
                            <div className='flex items-center mt-[16px] separator-bottom pb-[16px]'>
                            <p className='heading-h6 text-left'>{props.details.me.roundScore} pts</p>
                                <p className='grow text-secundary text-center '>{TranslateService.get('indivualChall.challenges.round.modal.scoreR')}</p>
                                <p className='heading-h6 text-right'>{props.details.opponent.roundScore} pts</p>
                            </div>
                            <div className='flex items-center mt-[16px]'>
                                <p className='heading-h6 text-left'>{props.details.me.right}</p>
                                <p className='grow text-secundary text-center '>{TranslateService.get('indivualChall.challenges.round.modal.right')}</p>
                                <p className='heading-h6 text-right'>{props.details.opponent.right}</p>
                            </div>
                            <div className='flex items-center mt-[16px] separator-bottom pb-[16px]'>
                                <p className='heading-h6 text-left'>{UtilsService.round(props.details.me.time)}s</p>
                                <p className='grow text-secundary text-center '>{TranslateService.get('indivualChall.challenges.round.modal.time')}</p>
                                <p className='heading-h6 text-right'>{props.details.opponent.time}s</p>
                            </div>
                            <div className='flex items-center mt-[16px]'>
                                <p className='heading-h6 text-left'>{UtilsService.round(props.details.me.wrong)}</p>
                                <p className='grow text-secundary text-center '>{TranslateService.get('indivualChall.challenges.round.modal.wrong')}</p>
                                <p className='heading-h6 text-right'>{props.details.opponent.wrong}</p>
                            </div>
                            <div className='flex items-center mt-[16px]'>
                                <p className='heading-h6 text-left'>{props.details.me.roundsWon}</p>
                                <p className='grow text-secundary text-center '>{TranslateService.get('indivualChall.challenges.round.modal.won')}</p>
                                <p className='heading-h6 text-right'>{props.details.opponent.roundsWon}</p>
                            </div>

                    </div>
                    }
                    


                    <Button onClick={handleDone}>
                        {props.details.nextRound && TranslateService.get('indivualChall.challenges.round.next')}
                        {!props.details.nextRound && TranslateService.get('indivualChall.challenges.round.modal.btn')}
                        
                    </Button>
                </div>
            </div>
        </div>
    )
}